/* Shared horizontal product carousel.
 *
 * Used by sections/featured-collection.liquid and sections/related-products.liquid so the
 * scroll / arrow / dots behaviour lives in one place instead of being copy-pasted (and drifting).
 *
 * Markup contract (scoped to the [data-carousel] element):
 *   [data-carousel]            wrapper the JS is scoped to
 *   [data-carousel-track]      the horizontally-scrolling flex row of .product-card children
 *   [data-carousel-prev]       previous-page button
 *   [data-carousel-next]       next-page button
 *   [data-carousel-dots]       OPTIONAL container; when present, pagination dots are rendered
 *
 * Auto-initializes every [data-carousel] present at load. For carousels whose cards load
 * asynchronously (recommendations), omit data-carousel on the skeleton and call
 * window.RainupCarousel.init(el) once the real cards are in the DOM.
 */
(function () {
  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.carouselInit) return;
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    var dots = carousel.querySelector('[data-carousel-dots]');
    if (!track || !prev || !next) return;
    carousel.dataset.carouselInit = '1';

    function metrics() {
      var firstCard = track.querySelector('.product-card');
      if (!firstCard) return { card: 0, gap: 0, perPage: 1 };
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '0');
      var card = firstCard.offsetWidth;
      var perPage = Math.max(1, Math.round((track.clientWidth + gap) / (card + gap)));
      return { card: card, gap: gap, perPage: perPage };
    }
    function pageStep() { var m = metrics(); return m.perPage * (m.card + m.gap); }
    function pageCount() { var m = metrics(); return Math.max(1, Math.ceil(track.children.length / m.perPage)); }
    function currentPageIdx() { var step = pageStep(); return step ? Math.round(track.scrollLeft / step) : 0; }

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.setAttribute('aria-disabled', track.scrollLeft <= 1 ? 'true' : 'false');
      next.setAttribute('aria-disabled', track.scrollLeft >= max ? 'true' : 'false');
    }

    function buildDots() {
      if (!dots) return;
      var count = pageCount();
      if (count <= 1) { dots.innerHTML = ''; dots.style.display = 'none'; return; }
      dots.style.display = '';
      if (dots.children.length !== count) {
        dots.innerHTML = '';
        for (var i = 0; i < count; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'carousel__dot';
          b.dataset.page = String(i);
          b.setAttribute('aria-label', 'Go to page ' + (i + 1));
          dots.appendChild(b);
        }
      }
      updateActiveDot();
    }
    function updateActiveDot() {
      if (!dots || !dots.children.length) return;
      var idx = currentPageIdx(), last = dots.children.length - 1;
      if (idx < 0) idx = 0; else if (idx > last) idx = last;
      for (var i = 0; i < dots.children.length; i++) {
        var on = i === idx;
        dots.children[i].classList.toggle('is-active', on);
        if (on) dots.children[i].setAttribute('aria-current', 'true');
        else dots.children[i].removeAttribute('aria-current');
      }
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -pageStep(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: pageStep(), behavior: 'smooth' }); });
    if (dots) {
      dots.addEventListener('click', function (ev) {
        var b = ev.target.closest('[data-page]');
        if (!b) return;
        track.scrollTo({ left: (parseInt(b.dataset.page, 10) || 0) * pageStep(), behavior: 'smooth' });
      });
    }

    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { updateArrows(); updateActiveDot(); });
    });
    window.addEventListener('resize', function () { buildDots(); updateArrows(); });

    buildDots();
    updateArrows();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(initCarousel);
  }

  window.RainupCarousel = { init: initCarousel, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
